import React from "react";
import { Box, MenuItem, TextField } from "@mui/material";
import { DropDownComboOption } from "./GenericFilter";
import { useStyles } from "./SideNavBar";
import { globalTheme } from "../../common/theme";

export type DropDownTextBoxProps = {
    dropDownBoxId?: string;
    dropDownBoxLabel?: string;
    dropDownBoxDisabled: boolean;
    className: string;
    dropDownBoxWidth: string;
    dropDownBoxOptions: DropDownComboOption[];
    dropDownBoxValue: string;
    firstTextBoxLabel?: string;
    firstTextBoxName?: string;
    firstTextBoxValue?: string;
    firstTextBoxWidth?: string
    firstTextBoxMinWidth?: string;
    secondTextBoxName?: string;
    secondTextBoxValue?: string;
    onSelectionChanged: Function;
    onTextBoxValueChanged?: Function;
    secondTextBoxVisibility?: boolean;
}

export function CustomDropDown2(props: DropDownTextBoxProps ) {
    const componentStyle = {
        display: 'flex'
    };
    
    const style = { ...useStyles(), ...globalTheme() };

    const revisionLabelStyle = {
        border: "none",
        width: '30px',
        height: '56px',
        paddingTop: 10,
        paddingLeft: 8,
        display: props.secondTextBoxVisibility ? 'inline' : 'none'
    };
      
    const [selectedValue, setSelectedValue] = React.useState<string | null>(props.dropDownBoxValue);

    const selectedValueChanged = (newValue: string | null) => {
        setSelectedValue(newValue);
        props.onSelectionChanged(newValue);
    };

    const valueChanged = (newValue: string | null) => {
        if (props.onTextBoxValueChanged)
            props.onTextBoxValueChanged(newValue);
    };

    return (
        <div className={props.className} style={componentStyle}>
            <TextField
                id={props.dropDownBoxId}
                style={{width: props.dropDownBoxWidth, minWidth: props.dropDownBoxWidth}}
                value={selectedValue}
                onChange={(e) => selectedValueChanged(e.target.value)}
                select
                label={props.dropDownBoxLabel}
                disabled={props.dropDownBoxDisabled}
                size="small"
                fullWidth
            >
                {props.dropDownBoxOptions.map((item)=> (
                    <MenuItem key={item.value} value={item.value}>
                        {item.name}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                label={props.firstTextBoxLabel}
                InputLabelProps={{ shrink: true }}
                name={props.firstTextBoxName}
                value={props.firstTextBoxValue}
                variant="outlined"
                inputProps={
                    { readOnly: true, }
                }
                style={{width: props.firstTextBoxWidth, minWidth: props.firstTextBoxMinWidth}}                      
                size="small"
                fullWidth
            />
            <Box style={revisionLabelStyle} display="flex" justifyContent="center" alignItems="center" >R</Box>
            <TextField
                name={props.secondTextBoxName}
                value={props.secondTextBoxValue}
                className={`${style.NumberTextField}`}
                type="number"
                inputProps={{ maxLength: 1 }}
                variant="outlined"
                style={{width: '38px', minWidth: '38px', visibility: props.secondTextBoxVisibility ? 'visible' : 'hidden'}}                      
                onChange={(e) => valueChanged(e.target.value)}
                size="small"
                fullWidth
            />
        </div>
    );
}

